// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/@expo/webpack-config/node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("./flow.css");
var ___HTML_LOADER_IMPORT_1___ = require("./flow.js");
// Module
var ___HTML_LOADER_REPLACER_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACER_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var code = "<link rel=stylesheet href=" + ___HTML_LOADER_REPLACER_0___ + " /> <div class=grid></div> <script src=" + ___HTML_LOADER_REPLACER_1___ + "></script>";
// Exports
module.exports = code;